import {isTicketed} from '@wix/wix-events-commons-statics'
import {handleCacheRestore, handleInitialNavigation, navigate} from '../actions/navigation'
import {placeOrder, updateOrder} from '../actions/placed-order'
import {makeReservation} from '../actions/reservation'
import {sendRsvp, sendRsvpOld, updateRsvp, updateRsvpOld} from '../actions/rsvp'
import {refreshAvailableTickets} from '../actions/tickets'
import {State} from '../types/state'
import {getEvent} from './event'
import {inDetails} from './navigation'

export const isRequestPending = (state: State, actionType: string) => !!state.pendingRequests.loading[actionType]

export const isTicketAvailabilityRefreshPending = (state: State): boolean =>
  isRequestPending(state, refreshAvailableTickets.typePrefix) ||
  (inDetails(state) && isTicketed(getEvent(state)) && isRequestPending(state, handleCacheRestore.typePrefix))

export const isTicketSelectionPending = (state: State): boolean =>
  isRequestPending(state, makeReservation.typePrefix) || isTicketAvailabilityRefreshPending(state)

export const isCheckoutActionPending = (state: State): boolean => {
  const updateOrderInProgress = isRequestPending(state, updateOrder.typePrefix)

  const placeOrderInProgress = isRequestPending(state, placeOrder.typePrefix)

  const ticketSelectionInProgress = isTicketSelectionPending(state)

  const navigateInProgress = isRequestPending(state, navigate.typePrefix)

  const initialNavigationInProgress = isRequestPending(state, handleInitialNavigation.typePrefix)

  return (
    updateOrderInProgress ||
    placeOrderInProgress ||
    ticketSelectionInProgress ||
    (navigateInProgress && !initialNavigationInProgress)
  )
}

export const isRsvpActionPending = (state: State): boolean => {
  const sendRsvpInProgress = isRequestPending(state, sendRsvp.typePrefix)

  const sendRsvpOldInProgress = isRequestPending(state, sendRsvpOld.typePrefix)

  const updateRsvpInProgress = isRequestPending(state, updateRsvp.typePrefix)

  const updateRsvpOldInProgress = isRequestPending(state, updateRsvpOld.typePrefix)

  return sendRsvpInProgress || sendRsvpOldInProgress || updateRsvpInProgress || updateRsvpOldInProgress
}
